import styled from 'styled-components'
import { colors } from '../styles'

export const ContinuationList = styled.ul`
  padding: 0;
  li,
  div {
    all: unset;
    display: flex;
    align-items: center;
    padding: 4px 0 4px 8px;

    &:hover {
      background: ${colors.greenLight};
    }

    & > * {
      padding-right: 12px;
    }

    .icon {
      font-size: 32px;
    }

    .name {
      font-weight: bold;
      flex: 1;
    }
    .revision {
      font-weight: bold;
      flex: 1;
      text-align: left;
    }
    .date {
      color: ${colors.grey40};
      flex: 1;
      text-align: left;
    }
    .message {
      flex: 2;
      text-align: left;
    }

    p {
      word-break: break-word;
    }
  }
  a {
    cursor: pointer;
  }

  .list-header {
    display: flex;
    padding-left: 55px;

    & > p {
      color: ${colors.grey40};
      flex: 1;
      text-align: left;
      font-size: 14px;
      font-weight: bold;
      padding-right: 10px;

      &.large {
        flex: 2;
      }
    }
  }

  .list-footer {
    justify-content: center;
    &:hover {
      background: initial;
    }
    .no-items-text {
      color: ${colors.grey40};
      padding: 16px 0;
    }
  }
`
